export default __webpack_public_path__ + "static/media/1664.3fce806c.png";